const CircleCheckIcon = () => (
  <svg
    width='42'
    height='42'
    viewBox='0 0 40 40'
    fill='none'
    role='img'
    aria-label='Circle Check Icon'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M20 37.5C10.35 37.5 2.5 29.65 2.5 20C2.5 10.35 10.35 2.5 20 2.5C29.65 2.5 37.5 10.35 37.5 20C37.5 29.65 29.65 37.5 20 37.5ZM20 5C11.7247 5 5 11.7247 5 20C5 28.2753 11.7247 35 20 35C28.2753 35 35 28.2753 35 20C35 11.7247 28.2753 5 20 5ZM18.925 27.4877C19.2625 27.4377 19.575 27.2502 19.775 26.9627L28.525 14.4627C28.925 13.9002 28.7875 13.1127 28.2125 12.7252C27.65 12.3252 26.8625 12.4627 26.475 13.0377L18.4873 24.45L13.275 20.2877C12.7375 19.8502 11.95 19.9502 11.5125 20.4877C11.0875 21.0252 11.175 21.8127 11.7125 22.2502L17.9625 27.2502C18.1875 27.4252 18.4625 27.5252 18.7375 27.5252C18.8 27.5252 18.85 27.5252 18.9125 27.5127L18.925 27.4877Z'
      fill='currentColor' />
  </svg>
)

export default CircleCheckIcon